import { FC } from 'react';
import { Box, Stack, Text, Button } from '@chakra-ui/react';

type Props = {
  /** メニューカテゴリー追加 */
  handleClickAdd: () => void;
};

export const MenuCategoryListEmpty: FC<Props> = ({ handleClickAdd }) => (
  <Box
    m={0}
    w="100%"
    h="100%"
    textAlign="center"
    border="none"
    color="primaryList.item.color"
    cursor="pointer"
    py="32px"
  >
    <Stack
      spacing="12px"
      direction="row"
      alignItems="center"
      justifyContent="center"
    >
      <Text color="gray.500">カテゴリーが登録されていません</Text>
      <Button colorScheme="blue" size="sm" onClick={handleClickAdd}>
        カテゴリー追加
      </Button>
    </Stack>
  </Box>
);
